module.exports = __webpack_public_path__ + "img/SES_20151213.52f1e427.jpg";